var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.125C16.8975 11.125 17.625 10.3975 17.625 9.5C17.625 8.60254 16.8975 7.875 16 7.875C15.1025 7.875 14.375 8.60254 14.375 9.5C14.375 10.3975 15.1025 11.125 16 11.125Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.625C16.8975 17.625 17.625 16.8975 17.625 16C17.625 15.1025 16.8975 14.375 16 14.375C15.1025 14.375 14.375 15.1025 14.375 16C14.375 16.8975 15.1025 17.625 16 17.625Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24.125C16.8975 24.125 17.625 23.3975 17.625 22.5C17.625 21.6025 16.8975 20.875 16 20.875C15.1025 20.875 14.375 21.6025 14.375 22.5C14.375 23.3975 15.1025 24.125 16 24.125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDropDown);
export default __webpack_public_path__ + "static/media/menuDropDown.be506e63dc91b11355bf9ebd6dd88ae2.svg";
export { ForwardRef as ReactComponent };